export const DESPACHO_TIPOS = [
  { id: 'deferimento', label: 'Deferimento' },
  { id: 'indeferimento', label: 'Indeferimento' },
  { id: 'exigencia', label: 'Exigência' },
  { id: 'ciencia', label: 'Ciência' },
  { id: 'outro', label: 'Outro' },
];

export const DESPACHO_PLACEHOLDERS = [
  { key: 'numero_processo', label: 'Nº do processo' },
  { key: 'numero_despacho', label: 'Nº do despacho' },
  { key: 'data', label: 'Data' },
  { key: 'orgao', label: 'Órgão' },
];

export function despachoStatusMeta(status) {
  if (status === 'publicado') {
    return { label: 'Publicado', tone: 'success', editable: false };
  }
  return { label: 'Rascunho', tone: 'slate', editable: true };
}

export function despachoTipoLabel(tipo) {
  return DESPACHO_TIPOS.find((item) => item.id === tipo)?.label || 'Despacho';
}

export function defaultDespachoCorpo({ processoNumero, orgaoNome } = {}) {
  return `DESPACHO

Processo nº {{numero_processo}}

Considerando a análise dos autos do processo ${processoNumero || '{{numero_processo}}'},
no âmbito de ${orgaoNome || '{{orgao}}'},

DECIDO:

`;
}
